import React, { useState } from "react";
import Agreement from "../assets/affiliate/Agreement.png";
import Commission from "../assets/affiliate/high-commision.png";
import FastPayment from "../assets/affiliate/fast-payment.png";
import QuickStart from "../assets/affiliate/quick-start.png";
import { Tab, Tabs, Accordion, Card } from "react-bootstrap";
import RegisterModal from "../components/Affiliate/RegisterModal";
function Affiliate() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="affiliate">
      <RegisterModal openModal={show} closeModal={handleClose} />
      <div className="container">
        <div className="row ">
          <div className="col-md-6 order-2 order-md-1">
            <h1 className="title p-0">
              Become a Clapingo{" "}
              <span style={{ color: "#4DC591" }}>affiliate</span>
            </h1>
            <p className="subtitle pt-0 mt-md-3 mt-2">
              Be a part of the fastest-growing Spoken English platform in India.
              Join our community of influencers, teachers and professionals who
              help our learners become the best version of themselves. Earn
              every time someone subscribes to Clapingo through your referral.
            </p>
            <button className="register mt-3" onClick={() => handleShow()}>
              Register and start to earn
              <i className="fas fa-arrow-right text-white ml-4"></i>
            </button>
          </div>

          <div className="col-md-6 order-1 order-md-2">
            <img
              className="mx-auto d-block mt-5 img-fluid"
              src={Agreement}
              alt="Affiliate image"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="cardx">
              <div className="rowA">
                <div className="columnA">
                  <h3 className="card_title">What is affiliate program?</h3>
                  <p className="mt-md-5 mt-3 first">
                    An “affiliate program” is a relationship in which a merchant
                    (Clapingo) pays “the affiliate” (You) for referring
                    potential clients from your site to theirs (Clapingo.com).
                  </p>
                </div>
                <div className="columnA ">
                  <h3 className="card_title">
                    Who needs to be a part of
                    <br /> affiliate program?
                  </h3>
                  <p className="mt-md-4 mt-3 second">
                    • <strong>Influencers</strong> •{" "}
                    <strong>Teachers/Professionals</strong> •{" "}
                    <strong>Enthusiasts</strong>
                    <br />
                    <br />
                    <span>
                      You have a passion for growth and want to share your
                      journey with your fans. Whether you are just starting out
                      or if you already have an established brand, the affiliate
                      program helps you and your followers take that first step
                      towards your Spoken English goals.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="traffic">
          <h1 className="traffic_title">
            Your <span style={{ color: "#4DC591" }}>traffic</span> is valuable
            <br />
            Why should you <span style={{ color: "#4DC591" }}>send</span> it to
            us?
          </h1>
          <div className="row mt-5">
            <div className="col-md-4 ">
              <div className="traffic_card text-center pt-5">
                <div className="card-box">
                  <div className="box normal">
                    <img src={QuickStart} alt="quick start" />
                  </div>
                  <div className="box rotate"></div>
                </div>

                <h3 className="mt-5">Quick Start</h3>
                <p>
                  Fill out the form and receive a personalized link to share
                  with your community. Promote your referral code on the
                  platform of your choice and track your earnings through the
                  affiliate dashboard.
                </p>
              </div>
            </div>
            <div className="col-md-4 mt-md-0 mt-3 ">
              <div className="traffic_card text-center pt-5">
                <div className="card-box">
                  <div className="box normal">
                    <img src={FastPayment} alt="fast payment" />
                  </div>
                  <div className="box rotate"></div>
                </div>
                <h3 className="mt-5">Fast Payments</h3>
                <p>
                  Fastest payment cycles in the industry. Commission gets
                  deposited directly to your bank account every Sunday(Weekly
                  payment).
                </p>
              </div>
            </div>
            <div className="col-md-4 mt-md-0 mt-3">
              <div className="traffic_card text-center pt-5">
                <div className="card-box">
                  <div className="box normal">
                    <img src={Commission} alt="high comision" />
                  </div>
                  <div className="box rotate"></div>
                </div>
                <h3 className="mt-5">High Commissions</h3>
                <p>
                  Get paid to introduce Clapingo to your network at discounted
                  rates. Earn big and introduce a new source of income into your
                  life.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="what_affiliates_say">
                <div className="row content">
                    <div className="col-md-4">
                        <h3>What affiliates<br /> <span style={{ color: "#4DC591" }}>say</span> about us</h3>
                        <p className="pr-5 mt-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.</p>
                    </div>
                    <div className="col-md-8">
                        <div className="row mt-4">
                            <div className="col-md-4">
                                <div className="affiliate_card">
                                    <img className="mt-4 ml-4" src={Placeholder}/>
                                    <h4 className="ml-4 mt-2">Selena Gomz</h4>
                                    <span className="ml-4">22 years old</span>
                                    <p className="mt-5 ml-4 pr-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="affiliate_card">
                                    <img className="mt-4 ml-4" src={Placeholder}/>
                                    <h4 className="ml-4 mt-2">Selena Gomz</h4>
                                    <span className="ml-4">22 years old</span>
                                    <p className="mt-5 ml-4 pr-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="affiliate_card">
                                    <img className="mt-4 ml-4" src={Placeholder}/>
                                    <h4 className="ml-4 mt-2">Selena Gomz</h4>
                                    <span className="ml-4">22 years old</span>
                                    <p className="mt-5 ml-4 pr-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            */}
        <div className="faq">
          <h1>
            Have a question?
            <br />
            Find the answers in our{" "}
            <span style={{ color: "#4DC591" }}>FAQ</span>:
          </h1>
          <div className="tab">
            <Tabs defaultActiveKey="general" id="uncontrolled-tab-example">
              <Tab eventKey="general" title="General">
                <Accordion defaultActiveKey="0">
                  <Card className="mt-5  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="1"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">1</div>
                        <p className="ml-3">
                          How do I apply to be a Clapingo Affiliate?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        You can register through the form available on this
                        page. All you need to do is provide the details required
                        and post-approval you will receive your unique referral
                        code and dashboard access.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="2"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">2</div>
                        <p className="ml-3">
                          How much can I earn through this affiliate program?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        Clapingo will pay 5% per subscriber referred through
                        your unique referral code (Excluding GST). All payments
                        will be made via Online bank transfer every Sunday. You
                        can track your earnings in real-time through your
                        Affiliate Dashboard.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="3"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">3</div>
                        <p className="ml-3">
                          What documents/details do I need to provide for my
                          application?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="3">
                      <Card.Body>
                        In order to register as a Clapingo Affiliate, you will
                        need to fill the form with the necessary details. Please
                        make sure you fill all the required fields with the
                        correct information for your account approval.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="4"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">4</div>
                        <p className="ml-3">
                          How long will it take for my account to get verified?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="4">
                      <Card.Body>
                        We are just as excited as you are to start this journey.
                        Our team will respond to your application within 72
                        hours of your application. For more queries, you can
                        contact us at{" "}
                        <a href="mailto:affiliate@clapingo.com">
                          affiliate@clapingo.com
                        </a>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="5"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">5</div>
                        <p className="ml-3">
                          What does my affiliate account dashboard show?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="5">
                      <Card.Body>
                        Your account dashboard will display all the recent
                        transactions recorded via your unique referral link
                        along with your weekly earnings
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="6"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">6</div>
                        <p className="ml-3">
                          How can I deactivate my affiliate account?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="6">
                      <Card.Body>
                        You can contact us at{" "}
                        <a href="mailto:affiliate@clapingo.com">
                          affiliate@clapingo.com
                        </a>{" "}
                        and we will initiate the process of deactivating your
                        account. The process can only be completed once our team
                        confirms that all the paperwork and legalities have been
                        complied with.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card className="mt-2  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="7"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">7</div>
                        <p className="ml-3">
                          How will the Clapingo Affiliate Program help me?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="7">
                      <Card.Body>
                        Clapingo’s affiliates program allows creators to
                        leverage their community and provide their
                        fans/followers to get a great deal by using their
                        referral code.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Tab>
              <Tab eventKey="advertising" title="Advertising">
                <Accordion defaultActiveKey="0">
                  <Card className="mt-5  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="0"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">1</div>
                        <p className="ml-3">
                          What platforms can I share my sessions on?
                        </p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        Once you receive your “Approved session download link”
                        from the Clapingo approval team, you are free to share
                        it on any social media platform of your choice.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Tab>
              <Tab eventKey="payment" title="Payment">
                <Accordion defaultActiveKey="0">
                  <Card className="mt-5  p-0">
                    <Accordion.Toggle
                      as={Card.Header}
                      className="accord"
                      eventKey="0"
                    >
                      <div className="d-flex">
                        <div className="circle my-auto">1</div>
                        <p className="ml-3">How do I get paid?</p>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        All payments will be made on Sunday. These payments will
                        be made via an online bank transfer.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Affiliate;
